import { Theme } from '@mui/material/styles'
import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    minWidth: 0,
    maxWidth: '100%',
  },
  textWrap: {
    minWidth: 0,
    maxWidth: `min(100%, ${theme.spacing(40)})`,
  },
  displayText: {
    display: 'inline-block',
    maxWidth: '100%',
    verticalAlign: 'middle',
  },
  icon: {
    cursor: 'pointer',
    fontSize: theme.spacing(1.75),
    verticalAlign: 'middle',
    color: theme.palette.text.secondary,
    flexShrink: 0,
    '&:hover': {
      opacity: 0.8,
    },
  },
  iconCopied: {
    color: theme.palette.success.main,
    opacity: 1,
  },
}))
